export const REWARD_LIFETIME_IN_SECONDS = 90
